import React from 'react';
import useCallbackContext from '../Components/Generic/CallbacksContext';
// These functions are used for mostly handling of complex form like Professional Step of Profile Journey
// Where there are multiple array of forms setup parallel to each other.


// This is used to handle the validation and submission of the forms via callback context.
// Used in scenarios where there are multiple sub forms 
// Example: Professional Step has multiple Profession, Responsibility and Achievements forms
// To ensure that any filled form which hasn't been submitted yet get analyzed these form must
// Register to the callback CallbackContext then useCallbackSubmission under Professional is used to
// Aggregate and callback the submission function of all the subforms.
export default function useFormCallback({formRef, onSubmit, isNew, symbol, forceCallback, isValid}) {
    const callbackContext = useCallbackContext();
    const formSymbol = React.useMemo(() => symbol || Symbol("form"), [symbol]);
    React.useEffect(() => {
        if (
            callbackContext?.addCallback
            && callbackContext?.removeCallback
            && (!isNew || (forceCallback && (typeof forceCallback !== "function" || forceCallback())))
        ) {
            const callback = async () => {
                if (formRef?.current) {
                    if (formRef?.current.reportValidity() && (typeof(isValid) !== "function" || isValid())) {
                        if (typeof onSubmit === "function") return await onSubmit();
                        else return true;
                    } else return false;
                } else {
                    if (typeof onSubmit === "function") return await onSubmit();
                    else return true;
                }
            }
            callback.symbol = formSymbol;
            callbackContext.addCallback(callback);
            return () => {
                callbackContext.removeCallback(callback);
            };

        }
    }, [isNew, formRef, onSubmit,formSymbol, callbackContext, isValid, forceCallback]);
    return callbackContext;
}

// This is used to trigger submission of all the subform so that the changes to data is set to the formdata
// NOTE: The forms are generally registered by the useFormCallback
// The onSubmit events are always set to returns the setter function
// example useProfileJourneyContext under ProfileJourneyContext.js has setFormData where formDataSetter is returned.
// This is done to ensure we can reduce the data from the submission of all the subforms before state changes.
export function useCallbackSubmission(onSubmit, mainSymbol) {
    const { callback } = useCallbackContext();
    const onFormSubmit = React.useCallback(async () => {
        if (typeof onSubmit !== "function") return true;
        const formDataSetters = typeof callback === "function"? await callback([mainSymbol]) : [];
        if (formDataSetters?.length) {
            if (formDataSetters.some(setter => setter === false)) return false;
            else return await onSubmit((data) => {
                return formDataSetters.reduce((acc, setter) => {
                    if (typeof setter === "function")  return setter(acc);
                    else if (typeof setter === "object") return {...acc, ...setter};
                    else return acc;
                }, data);
            });
        } else {
            return await onSubmit();
        }
    }, [onSubmit, mainSymbol, callback]);

    return onFormSubmit;
}
